<template>
  <div>
    <template-item
      label="备选项"
      layout="flex"
      content-classes="flex flex-column"
      content-styles="line-height: 29px;"
    >
      <span class="flex-auto" style="display: inline-block;">
        <el-radio-group v-model="constraintTypeData">
          <el-tooltip
            placement="top-start"
            content="以最新数据源为准,会随着数据源数据的更新而更新"
            ><el-radio :label="1" :key="1"
              >全部(实时最新数据)</el-radio
            ></el-tooltip
          ><el-tooltip
            v-if="allowedCurrent"
            placement="top-start"
            content="以当前数据源为准,不会随着数据源数据的更新而更新"
            ><el-radio :label="2" :key="2">全部(当前数据)</el-radio></el-tooltip
          >
          <el-tooltip placement="top-start" content="永远使用当前最新数据"
            ><el-radio :label="3" :key="3">自定义</el-radio></el-tooltip
          >
        </el-radio-group>
      </span>
      <slot v-if="custom" name="allowed" />
    </template-item>
    <template-item label="禁选项" layout="flex">
      <template v-slot:contentWrapper>
        <slot name="forbidden" />
      </template>
    </template-item>
  </div>
</template>
<script>
import { Divider, RadioGroup, Radio, Tooltip } from "element-ui";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";
export default {
  name: "common-selector-constraint-wrapper",
  components: {
    TemplateItem,
    [Divider.name]: Divider,
    [Tooltip.name]: Tooltip,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },
  props: {
    constraintType: {
      type: Number,
      required: true,
    },
    allowedCurrent: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "constraintType",
    event: "change",
  },
  computed: {
    constraintTypeData: {
      get() {
        return this.$props.constraintType;
      },
      set(value) {
        this.$emit("change", value);
      },
    },
    latest() {
      return this.constraintTypeData === 1;
    },
    current() {
      return this.constraintTypeData === 2;
    },
    custom() {
      return this.constraintTypeData === 3;
    },
  },
  methods: {
    needCompute(value) {
      if (value) {
        return value === 2;
      }
      return this.$props.constraintType === 2;
    },
    isLatest(value) {
      if (value) {
        return value === 1;
      }
      return this.constraintTypeData === 1;
    },
    isCurrent(value) {
      if (value) {
        return value === 2;
      }
      return this.constraintTypeData === 2;
    },
    isCustom(value) {
      if (value) {
        return value === 3;
      }
      return this.constraintTypeData === 3;
    },
  },
};
</script>
